import {getTenCosConfig, getTenCosConfigForImage, getCdnDomain} from '@/api/system/upload.js'

export default class UploadFileToVOD {
  constructor(files, json) {
    if (!Array.isArray(files)) {
      throw new Error('Class UploadFileToOSS parameter must be an array');
    }
    this.data = [];
    this.fn = json.success;
    this.complete = json.finally;
    this.vProgress = json.vProgress;
    this.fileId = json.fileId;
    this.error = json.error; // 错误回调
    this.files = files;
    this.fileLen = this.files.length;
    this.curIndex = 0;
    this.hasRetried = false; // 是否已经重试过
    // 封面图：不替换 CDN，保持 *.vod-qcloud.com
    this.skipCdnRewrite = !!json.skipCdnRewrite;
    // 封面图：签名不带 AdaptiveHls 任务流
    this.forImage = !!json.forImage;
    this.upload();
  }


  upload(useDynamicAccelerate = true) {
    const that = this;
    
    // 清除之前的超时定时器
    if (this.uploadTimeoutTimer) {
      clearTimeout(this.uploadTimeoutTimer)
      this.uploadTimeoutTimer = null
    }
    if (this.progressTimeoutTimer) {
      clearTimeout(this.progressTimeoutTimer)
      this.progressTimeoutTimer = null
    }
    if (this.initTimeoutTimer) {
      clearTimeout(this.initTimeoutTimer)
      this.initTimeoutTimer = null
    }
    
    // 进度跟踪
    let lastProgressTime = Date.now()
    let lastProgressPercent = 0
    let uploadStarted = false // 标记上传是否真正开始
    
    const tcVod = new TcVod.default({
      getSignature: that.forImage ? getTenCosConfigForImage : getTenCosConfig,
      dynamicAccelerate: useDynamicAccelerate,
    })

    const uploader = tcVod.upload({
      mediaFile: this.files[0], // 媒体文件（视频或音频或图片），类型为 File
      // fileParallelLimit:10,
      // chunkParallelLimit:10,
      // dynamicAccelerate:true
    })
    
    // 初始化阶段超时检测（30秒内如果没有进度更新，说明查询分片上传列表卡住了）
    this.initTimeoutTimer = setTimeout(() => {
      if (!uploadStarted) {
        console.error('初始化超时（可能是查询分片上传列表卡住），尝试关闭动态加速重新上传...')
        // 取消当前上传
        if (uploader.cancel) {
          uploader.cancel()
        }
        
        // 如果使用了动态加速，先关闭动态加速重试
        if (useDynamicAccelerate && !that.hasRetried) {
          that.hasRetried = true
          setTimeout(() => {
            that.upload(false)
          }, 1000)
        } else {
          // 如果已经重试过，报错
          const err = new Error('上传初始化超时（可能是网络问题），请检查网络连接或关闭翻墙后重试')
          if (that.error) {
            that.error(err)
          }
          if (that.complete) {
            that.complete([])
          }
        }
      }
    }, 30000) // 30秒初始化超时
    
    // 监听进度事件
    uploader.on('media_progress', function (info) {
      const currentTime = Date.now()
      const currentPercent = info.percent || 0
      
      // 标记上传已开始
      if (!uploadStarted) {
        uploadStarted = true
        // 清除初始化超时定时器
        if (that.initTimeoutTimer) {
          clearTimeout(that.initTimeoutTimer)
          that.initTimeoutTimer = null
        }
      }
      
      // 更新进度
      lastProgressTime = currentTime
      lastProgressPercent = currentPercent
      
      // 清除之前的进度超时定时器
      if (that.progressTimeoutTimer) {
        clearTimeout(that.progressTimeoutTimer)
      }
      
      // 如果进度有更新，更新进度回调
      if (that.vProgress) {
        that.vProgress(currentPercent)
      }
      
      // 设置新的进度超时检测（如果进度在60秒内没有变化，认为卡住了）
      that.progressTimeoutTimer = setTimeout(() => {
        // 如果进度长时间不动，取消当前上传并重试
        if (uploader.cancel) {
          uploader.cancel()
        }
        
        // 如果使用了动态加速，先关闭动态加速重试
        if (useDynamicAccelerate && !that.hasRetried) {
          that.hasRetried = true
          setTimeout(() => {
            that.upload(false)
          }, 1000)
        } else {
          // 如果已经重试过，报错
          const err = new Error('上传进度卡住，请检查网络连接后重试')
          if (that.error) {
            that.error(err)
          }
          if (that.complete) {
            that.complete([])
          }
        }
      }, 60000) // 60秒无进度更新则认为卡住
    })
    
    // 监听其他事件（已移除日志打印）
    uploader.on('video_upload', function(info) {
      // 视频上传事件
    })
    
    uploader.on('http_upload_progress', function(info) {
      // HTTP上传进度事件
    })

    // 设置总的上传超时（10分钟）
    const fileSize = this.files[0].size || 0
    const fileSizeMB = fileSize / 1024 / 1024
    // 根据文件大小动态设置超时时间，最小10分钟，每MB增加10秒，最多30分钟
    const timeoutMs = Math.max(600000, Math.min(1800000, fileSizeMB * 10000 + 600000))
    
    this.uploadTimeoutTimer = setTimeout(() => {
      console.error('上传超时，取消上传')
      if (uploader.cancel) {
        uploader.cancel()
      }
      
      const err = new Error('上传超时，请检查网络连接后重试')
      
      // 如果使用了动态加速，先关闭动态加速重试
      if (useDynamicAccelerate && !that.hasRetried) {
        that.hasRetried = true
        setTimeout(() => {
          that.upload(false)
        }, 1000)
      } else {
        if (that.error) {
          that.error(err)
        }
        if (that.complete) {
          that.complete([])
        }
      }
    }, timeoutMs)

    uploader.done().then(function (doneResult) {
      // 清除所有定时器
      if (that.uploadTimeoutTimer) {
        clearTimeout(that.uploadTimeoutTimer)
        that.uploadTimeoutTimer = null
      }
      if (that.progressTimeoutTimer) {
        clearTimeout(that.progressTimeoutTimer)
        that.progressTimeoutTimer = null
      }
      if (that.initTimeoutTimer) {
        clearTimeout(that.initTimeoutTimer)
        that.initTimeoutTimer = null
      }
      
      // 获取原始URL（封面保持 vod-qcloud.com，不要换成 cdn.yourstc.store）
      let videoUrl = doneResult.video.url;
      
      const cdnDomain = getCdnDomain();
      if (!that.skipCdnRewrite && cdnDomain && videoUrl) {
        try {
          const urlPattern = /^https?:\/\/[^\/]+/;
          if (urlPattern.test(videoUrl)) {
            const protocol = videoUrl.startsWith('https') ? 'https://' : 'http://';
            videoUrl = videoUrl.replace(urlPattern, protocol + cdnDomain);
          }
          } catch (e) {
            // 替换CDN域名失败，使用原始URL
          }
      }
      
      that.data.push(videoUrl)
      // that.complete(that.data);
      if (that.fn) that.fn(that.data)
      if (that.fileId) that.fileId(doneResult.fileId)
      // 上传成功后也调用 finally 回调
      if (that.complete) {
        that.complete(that.data)
      }
      // deal with doneResult
    }).catch(function (err) {
      // 清除所有定时器
      if (that.uploadTimeoutTimer) {
        clearTimeout(that.uploadTimeoutTimer)
        that.uploadTimeoutTimer = null
      }
      if (that.progressTimeoutTimer) {
        clearTimeout(that.progressTimeoutTimer)
        that.progressTimeoutTimer = null
      }
      if (that.initTimeoutTimer) {
        clearTimeout(that.initTimeoutTimer)
        that.initTimeoutTimer = null
      }
      
      // 错误处理：如果使用动态加速失败，尝试关闭动态加速重试
      console.error('上传失败:', err)
      
      // 如果当前使用了动态加速，且还没有重试过，尝试关闭动态加速重新上传
      if (useDynamicAccelerate && !that.hasRetried) {
        that.hasRetried = true; // 标记已重试
        // 延迟一下再重试，避免立即重试
        setTimeout(() => {
          that.upload(false)
        }, 1000)
      } else {
        // 如果已经关闭了动态加速还是失败，或者已经重试过了，说明是其他错误
        console.error('上传最终失败:', err)
        const errorMsg = err.message || err.toString() || '上传失败，请检查网络连接'
        
        // 调用错误回调
        if (that.error) {
          that.error(err)
        }
        
        // 调用 finally 回调（表示上传结束，无论成功或失败）
        if (that.complete) {
          that.complete([])
        }
      }
    })


  }
}